// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b4e85df9","787":"77a5a048","802":"439f4e95"}[chunkId] + ".chunk.js";
};